exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/learner-learning-objectives.js-WebpackMultiOutput";